import type { LiveStatusDoc } from '../types';
import { CourtCard } from './CourtCard';
import { SampleCourtCard, SAMPLE_COURT_DOC } from './SampleCourtCard';
import { useIsHoliday } from '../hooks/useIsHoliday';

const STATUS_ORDER: Record<string, number> = { live: 0, idle: 1, list_over: 2, no_data: 3 };

interface Props {
  courts: LiveStatusDoc[];
  loading: boolean;
  onSelectCourt: (court: LiveStatusDoc) => void;
}

export function CourtGrid({ courts, loading, onSelectCourt }: Props) {
  const isHoliday = useIsHoliday();
  if (loading) {
    return (
      <div className="court-grid court-grid--loading">
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="court-card court-card--skeleton" />
        ))}
      </div>
    );
  }

  if (isHoliday === true || courts.length === 0) {
    const emptyMessage = isHoliday === true
      ? '🏛️ The court is closed today for a holiday. Here\'s what the live board looks like on a working day:'
      : 'Court is not in session right now. Here\'s what the live board looks like when cases are being heard:';
    return (
      <div>
        <div className="court-grid__empty">
          <p>{emptyMessage}</p>
        </div>
        <div className="court-grid">
          <SampleCourtCard onClick={() => onSelectCourt(SAMPLE_COURT_DOC)} />
        </div>
      </div>
    );
  }

  const sorted = [...courts].sort(
    (a, b) => (STATUS_ORDER[a.status] ?? 9) - (STATUS_ORDER[b.status] ?? 9)
  );

  return (
    <div className="court-grid">
      {sorted.map((court) => (
        <CourtCard
          key={court.id}
          court={court}
          onClick={() => onSelectCourt(court)}
        />
      ))}
    </div>
  );
}
